module.exports = __webpack_public_path__ + "assets/pdf/Cycle 1 CA ZEV Invest Plan Supplement.a92e7705.pdf";